<template>
  <div>
    <ChannelHeader
      image="assets/img/SB-Icons/api-icon-color.svg"
      background-color="#fff8ff"
      link="https://ainumber.com/connections/channels/whatsapp/number-whatsapp.html"
      title="Developers"
      :button="{ label: 'Documentation', action: devButton, icon: SBIconList.ARROW, iconColor: '#7f8b90', hoverIconColor: SBColors.blackPrimary, colored: true }" />

    <h3>Tools</h3>
    <div
      v-for="(item, index) in toolsItems"
      :key="index"
      class="item flex"
      @click="routeTo(item)" >
      <SBIcon
        class="mr-2"
        :icon="item.icon"
        :color="SBColors.blackPrimary"
        :size="14" />
      <p class="mr-2 greedy ellipsis">{{ item.label }}</p>
      <SBIcon
        class="hover-arrow"
        :icon="SBIconList.ARROW_LONG"
        :color="SBColors.greyPrimary"
        :size="14" />
    </div>
  </div>
</template>

<script>
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import ChannelHeader from './ChannelHeader';

export default {
  name: 'WhatsAppChannel',
  components: {
    ChannelHeader,
    SBIcon,
  },
  data() {
    return {
      toolsItems: [
        {
          label: 'API keys',
          icon: SBIconList.LOCK_CLOSED,
          target: 'ApiSettings',
        },
        {
          label: 'Webhooks',
          icon: SBIconList.WEBHOOK,
          target: 'WebhooksSettings',
        },
        {
          label: 'Webhook logs',
          icon: SBIconList.LOGS,
          target: 'WebhookLogsSettings',
        },
      ],
      SBIconList,
      SBColors,
    };
  },
  methods: {
    routeTo(item) {
      if (item.target) {
        this.$router.push({
          name: item.target,
        });
      } else {
        console.warn('Not implemented yet...');
      }
    },
    devButton() {
      window.open('https://developer.ainumber.com/', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin-top: 35px;
  font-size: 14px;
  font-weight: 400;
  color: $blackUltralight;
}

.item {
  margin-top: 12px;
  padding: 8px 10px;
  border-radius: 6px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
  border: solid 1px $greyBorder;
  background-color: $white;

  p {
    font-size: 14px;
    font-weight: normal;
    color: $blackPrimary;
  }

  .hover-arrow {
    display: none;
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);

    .hover-arrow {
      display: initial;
    }
  }
}
</style>
